<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat>
        <v-toolbar-title>Buying Prices List</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-col cols="3">
            <v-file-input
              v-model="excelFile"
              label="Browse Excel Sheet"
              outlined
              dense
            ></v-file-input>
          </v-col>

          <v-col cols="2">
            <v-btn color="accent" :loading="loader" @click="updateBp"
              >Update</v-btn
            >
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" xs="12" sm="12" md="7">
            <v-text-field
              name="inventorySearch"
              outlined
              dense
              label="Search"
              v-model="search"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="7">
            <!-- excel icon -->
            <download-excel
              :data="bpArray"
              :fields="fields"
              name="Buying Prices"
            >
              <v-icon color="green">mdi-file-excel</v-icon>
            </download-excel>
            <!-- end -->

            <!-- start of table -->
            <v-data-table
              loading-text="Loading Data......"
              :headers="headers"
              :items="bpArray"
              :search="search"
              :mobile-breakpoint="0"
            >
              <template v-slot:item.BuyingPrice="{ item }">{{
                item.BuyingPrice.toLocaleString()
              }}</template>

              <!-- action template -->
              <template v-slot:item.action="{ item }">
                <v-btn color="editIcon" @click="openModal(item)" text icon>
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <!-- end -->
            </v-data-table>
            <!-- end -->
          </v-col>
        </v-row>
      </v-card-text>

      <!-- Edit dialog -->
      <v-dialog v-model="dialog" max-width="700px">
        <v-card>
          <v-toolbar dense color="primary" dark>
            <v-toolbar-title>Edit Buying Price</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click.native="dialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-container fluid>
              <v-row class="displayText">
                <v-col cols="12" xs="12" md="12">
                  <span>{{ editItem.Name }}</span>
                </v-col>

                <v-col cols="12" xs="12" md="6">
                  <v-text-field
                    type="number"
                    autocomplete="off"
                    v-model="editItem.BuyingPrice"
                    label="Buying Price"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>

                <v-col cols="12" xs="12" md="6">
                  <v-text-field
                    type="number"
                    autocomplete="off"
                    v-model="editItem.AvgBuyingPrice"
                    label="Average Buying Price"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-btn color="accent" @click="save" :loading="loader">
                    <v-icon left>mdi-content-save</v-icon>Save
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
      <!-- end of edit dialog -->

      <!-- snackbar -->
      <snackbar ref="snackbar"></snackbar>
    </v-card>
  </v-container>
</template>

<script>
export default {
  computed: {
    activeStore() {
      return localStorage.getItem("store_id");
    },
  },
  data() {
    return {
      search: null,
      pageItems: 500,
      loader: false,
      editItem: {},
      excelFile: null,
      damagedItem: {},
      transferItem: {},
      store: null,
      stores: [],
      users: [],
      date: null,
      dialog: false,
      damageDialog: false,
      transferDialog: false,
      headers: [
        { text: "Product Name", value: "Name" },
        { text: "Available Qty", value: "AvailableQty" },
        { text: "Category", value: "Category" },
        { text: "Buying Price", value: "BuyingPrice" },
        { text: "Selling Price", value: "SellingPrice" },
        { text: "Action", value: "action" },
      ],
      bpArray: [],
      fields: {
        Id: "productId",
        Product: "Name",
        Category: "Category",
        Quantity: "AvailableQty",
        BuyingPrice: "BuyingPrice",
        SellingPrice: "SellingPrice",
      },
    };
  },
  methods: {
    updateBp() {
      const data = new FormData();
      data.append("pricesData", this.excelFile);
      const url = `/import-bp-prices`;
      const self = this;
      this.loader = true;
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.loader = false;
            location.reload();
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
            self.loader = false;
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    setDate(date) {
      this.date = date;
    },
    openModal(item) {
      this.editItem = Object.assign({}, item);
      this.dialog = true;
    },
    openDamageModal(item) {
      this.damagedItem = Object.assign({}, item);
      this.damageDialog = true;
    },
    openTransferModal(item) {
      this.transferItem = Object.assign({}, item);
      this.transferDialog = true;
    },
    getBp() {
      const id = this.activeStore;
      const self = this;
      self.$store.commit("loader", true);
      this.$store
        .dispatch("get", `/buying-prices/${id}`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.loader = false;
            self.bpArray = res.ResponseData;
            self.$store.commit("loader", false);
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
            self.$store.commit("loader", false);
          }
        })
        .catch((err) => {
          self.$store.commit("loader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    saveDamage() {
      const data = this.damagedItem;
      const TotalDamagedValue = parseInt(data.Quantity) * data.AvgBuyingPrice;
      data.TotalDamagedValue = TotalDamagedValue;
      data.DocDate = this.date;
      const url = `/spoiled-products`;
      // const self = this;
      this.loader = true;
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            location.reload();
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    save() {
      const data = this.editItem;
      const url = `/buying-prices/${data.id}`;
      // const self = this;
      this.loader = true;
      this.$store
        .dispatch("put", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            location.reload();
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getStores() {
      const self = this;
      this.$store
        .dispatch("get", `/stores`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.stores = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getUsers() {
      const self = this;
      this.$store
        .dispatch("get", `/users`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.users = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    Promise.all([this.getBp(), this.getStores(), this.getUsers()]);
  },
};
</script>

<style lang="scss" scoped>
</style>